import { render, staticRenderFns } from "./host-audit-info-company.vue?vue&type=template&id=ec567fa4&scoped=true&"
import script from "./host-audit-info-company.vue?vue&type=script&lang=js&"
export * from "./host-audit-info-company.vue?vue&type=script&lang=js&"
import style0 from "./host-audit-info-company.vue?vue&type=style&index=0&id=ec567fa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec567fa4",
  null
  
)

export default component.exports